import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import BannerContainer from './bannerContainer/';
import TitleContianer from './titleContianer';
import NewsListContainer from './newsListContainer/';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

class BodyContainer extends React.PureComponent {
    state = {
        animateConfig: {
            bannerFix: false,
            titleFix: false,
            pt450: false,
        },
    };
    static propTypes = {
        content: PropTypes.object,
    };

    // 监听滚动事件
    componentDidMount() {
        window.onscroll = () => {
            const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

            const winHeight = document.body.clientHeight;

            if (scrollTop > 217 && scrollTop <= winHeight - 300) {
                this.setState({
                    animateConfig: {
                        bannerFix: true,
                        titleFix: true,
                        pt450: true,
                    },
                });
            } else {
                this.setState({
                    animateConfig: {
                        bannerFix: false,
                        titleFix: false,
                        pt450: false,
                    },
                });
            }
        };
    }
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.mainBody}>
                <BannerContainer animateConfig={this.state.animateConfig} />
                <TitleContianer animateConfig={this.state.animateConfig} />
                <Chip id="75233" type="recommend" title="科技数据" groupName="正文" content={content}>
                    <NewsListContainer animateConfig={this.state.animateConfig} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(BodyContainer);
